import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { ErrorHandler, enableProdMode, inject, provideAppInitializer } from '@angular/core';
import { bootstrapApplication, provideClientHydration, withEventReplay, withHttpTransferCacheOptions } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, withPreloading } from '@angular/router';

import { AppComponent } from './app/app.component';
import { DEFAULT_HTTP_TRANSFER_CACHE_CONFIG } from './app/core/config/http-transfer-cache.config';
import { authInterceptor } from './app/core/interceptors/auth.interceptor';
import { ErrorHandlingService } from './app/core/services/error-handling/error-handling.service';
import { StoreConfigurationRepositoryService } from './app/core/services/store-configuration/store-configuration-repository.service';
import { SmartPreloadingStrategy } from './app/core/strategies/smart-preloading.strategy';
import { routes } from './app/routes';
import { environment } from './environments/environment';

// Import proper server error interceptor
import { serverErrorInterceptor } from './app/core/interceptors/server-error.interceptor';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    // Enable client hydration with event replay and HTTP transfer cache configuration
    provideClientHydration(
      withEventReplay(),
      withHttpTransferCacheOptions(DEFAULT_HTTP_TRANSFER_CACHE_CONFIG)
    ),
    provideHttpClient(
      withFetch(),
      withInterceptors([authInterceptor, serverErrorInterceptor])
    ),
    provideRouter(
      routes,
      withPreloading(SmartPreloadingStrategy)
    ),
    provideAnimations(),
    SmartPreloadingStrategy,
    { provide: ErrorHandler, useClass: ErrorHandlingService },
    // Preload store configuration early in the application lifecycle
    provideAppInitializer(() => {
      const storeConfigurationRepositoryService = inject(StoreConfigurationRepositoryService);
      return storeConfigurationRepositoryService.load().catch((error: any) => {
        return Promise.resolve();
      });
    })
  ]
}).catch(err => {
});
